import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { DateService } from '../../services/date.service';
import { RouterModule } from '@angular/router';
import { ModalsService } from '../../services/modals.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule, ModalDirective } from 'ngx-bootstrap/modal';
import { BadgeModule } from '@coreui/angular';
import { ApiAdminUsersService } from '../../services/admin-users/api/api-admin-users.service';
import { AdminUser } from '../../models/admin-users/admin-user.model';
import { AdminUserResultsResponse } from '../../models/admin-users/responses/api-admin-users-results-response.model';

@Component({
  templateUrl: 'admin-users.component.html',
  standalone: true,
  imports: [CollapseModule, FormsModule, RouterModule, CommonModule, BadgeModule, ModalModule]
})
export class AdminUsersComponent implements OnInit {

  @ViewChild('addUserModal') addUserModal!: ModalDirective;
  @ViewChild('editUserModal') editUserModal!: ModalDirective;
  @ViewChild('editUserPasswordModal') editUserPasswordModal!: ModalDirective;

  isLoading: boolean = false;
  users: AdminUser[] = [];
  newEmail: string = '';
  newPassword: string = '';
  editedEmail: string = '';
  editedPassword: string = '';
  private editedUserId: number = 0;

  constructor(public dateService: DateService, private apiAdminUsersService: ApiAdminUsersService, private alertsService: AlertsService, private modalsService: ModalsService) {}

  ngOnInit() {
    this.refreshUsersList();
  }

  addUser() {
    this.newEmail = '';
    this.newPassword = '';
    this.addUserModal.show();
  }

  saveAddUser() {
    this.isLoading = true;
    this.apiAdminUsersService.addAdminUser(this.newEmail, this.newPassword).then(() => {
      this.isLoading = false;
      this.addUserModal.hide();
      this.refreshUsersList();
      this.alertsService.displayAlertSuccess('User added !');
    }, error => {
      this.isLoading = false;
      this.alertsService.displayAlertError('Error adding user (' + error + ')');
    });
  }

  editUser(userId: number) {
    const user = this.users.find(u => u.userId === userId);
    this.editedUserId = userId;
    this.editedEmail = user?.email ?? '';
    this.editUserModal.show();
  }

  saveEditUser() {
    this.isLoading = true;
    this.apiAdminUsersService.editAdminUser(this.editedUserId, this.editedEmail).then(() => {
      this.isLoading = false;
      this.editUserModal.hide();
      this.refreshUsersList();
      this.alertsService.displayAlertSuccess('User updated !');
    }, error => {
      this.isLoading = false;
      this.alertsService.displayAlertError('Error updating user (' + error + ')');
    });
  }

  editUserPassword(userId: number) {
    this.editedUserId = userId;
    this.editedPassword = '';
    this.editUserPasswordModal.show();
  }

  saveEditUserPassword() {
    this.isLoading = true;
    this.apiAdminUsersService.editAdminUserPassword(this.editedUserId, this.editedPassword).then(() => {
      this.isLoading = false;
      this.editUserPasswordModal.hide();
      this.alertsService.displayAlertSuccess('Password updated !');
    }, error => {
      this.isLoading = false;
      this.alertsService.displayAlertError('Error updating password (' + error + ')');
    });
  }

  deleteUser(userId: number) {
    this.modalsService.showConfirmModal(
      () => {
        this.isLoading = true;
        this.apiAdminUsersService.deleteAdminUser(userId).then(() => {
          this.refreshUsersList();
          this.alertsService.displayAlertSuccess('User Deleted !');
        });
      });
  }

  private refreshUsersList() {
    this.isLoading = true;

    this.apiAdminUsersService.getAdminUsers().then(
      (result: AdminUserResultsResponse) => {
        this.isLoading = false;
        this.users = result.results;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error during user display (' + error + ')');
      }
    );
  }
}
